import axios from 'axios';
import { toDefaultRequestTransforms, toDefaultResponseTransforms } from '@peloton/api/client-transforms';
import { toApiLink, toExtLinkEnv, toHref } from '@peloton/external-links';
import { BaseAPI } from '@engage/api-v2';
import { API_ENVIRONMENT, PELOTON_PLATFORM } from '@webtv/env';
var extLink = toExtLinkEnv({
  api: API_ENVIRONMENT
});

var makeApiClient = function makeApiClient() {
  var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toHref(toApiLink('/'), extLink);
  var apiClient = axios.create({
    baseURL: baseURL,
    responseType: 'json',
    withCredentials: true,
    transformRequest: toDefaultRequestTransforms(),
    transformResponse: toDefaultResponseTransforms()
  });
  apiClient.interceptors.request.use(function (config) {
    config.headers['Peloton-Platform'] = PELOTON_PLATFORM;
    return config;
  });
  return apiClient;
};

var apiClient = makeApiClient();
var engageApi = new BaseAPI(apiClient);
var localClient = makeApiClient('/');
var localApi = new BaseAPI(localClient);
export { engageApi, apiClient, localApi };